import { DataTableColumns } from 'interfaces/DataTableColumns'
import Api from './Api'

class ZBoomParcel extends Api {
  readonly urls = {
    allParcels: '/ZBoomParcel/GetAllParcels',
    createParcel: '/ZBoomParcel/CreateParcel',
    updateParcel: '/ZBoomParcel/UpdateParcel',
    sendToZBoom: '/ZBoomParcel/SendToZBoom',
    getParcelDetail: '/ZBoomParcel/GetParcelDetail/',
    deleteParcel: '/ZBoomParcel/DeleteParcel',
    getParcelReceipt: '/ZBoomParcel/GetParcelReceipt/',
  }

  all = async (
    skip: number,
    top: number = 10,
    searchableColumns: DataTableColumns[] = [],
    searchText: string = '',
  ): Promise<any> => {
    var filter = 'true'
    if (searchText.trim() != '') {
      filter = `(contains(cast(originFullName,'Edm.String'),'${searchText}')or contains(cast(destinationFullName,'Edm.String'),'${searchText}'))`
    }
    const result = await this.postJsonData(
      `${this.urls.allParcels}?$top=${top}&$skip=${
        skip * top
      }&$orderby=id desc&$filter=${filter}`,
    )
    return result.data
  }

  create = async (data: any): Promise<any> => {
    const result = await this.postJsonData(
      this.urls.createParcel,
      data,
    )
    return result.data
  }

  sendToZBoom = async (id: number | string): Promise<any> => {
    const result = await this.postJsonData(
      this.urls.sendToZBoom,
      { id },
    )
    return result.data
  }

  getParcelDetail = async (id: number | string): Promise<any> => {
    const result = await this.getData(`${this.urls.getParcelDetail}${id}`)
    return result.data
  }

  updateParcel = async (data: any): Promise<any> => {
    const result = await this.postJsonData(this.urls.updateParcel, data)
    return result.data
  }

  deleteParcel = async (id: number | string): Promise<any> => {
    const result = await this.postJsonData(this.urls.deleteParcel, { id })
    return result.data
  }

  getParcelReceipt = async (id: number | string): Promise<any> => {
    const result = await this.getData(
      `${this.urls.getParcelReceipt}${id}`,
      { responseType: 'blob' }
    )
    return result
  }
}

export default new ZBoomParcel()
